// extracted by mini-css-extract-plugin
export default {"signUpHeading":"TcE3WLXrDjgCaMToApIy","signUpHeadingTitle":"qjlcG6Y1mxds4Pa1gvoA","signUpHeadingLogin":"C92eVmogXSUsfFUwLJkt"};